<template>
  <div class="account-page scrollable">
    <div class="page-header">
      <h1>Manual Tinder Scans</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>Manual Tinder Scans</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="top-bar">
      <div class="count-user">
        <p>Total Scans: {{ totalScans }}</p>
      </div>
      <div class="header-buttons">
        <button
          type="button"
          class="el-button el-button--primary"
          @click="$router.push('/manual-tinder-scans/create')"
        >
          <span>New Manual Scan</span>
        </button>
      </div>
    </div>

    <el-table :data="scans" style="width: 100%;" v-loading="loading">
      <el-table-column prop="id" label="ID" width="70"></el-table-column>
      <el-table-column label="User" min-width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.tinder_request && scope.row.tinder_request.user">
            {{ scope.row.tinder_request.user.email }}
          </span>
          <span v-else>N/A</span>
        </template>
      </el-table-column>
      <el-table-column label="Search Name" min-width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.tinder_request">{{ scope.row.tinder_request.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="radius" label="Radius (mi)" width="110"></el-table-column>
      <el-table-column label="Repeatable" width="120">
        <template slot-scope="scope">
          <el-tag :type="scope.row.repeatable ? 'success' : 'info'" size="small">
            {{ scope.row.repeatable ? 'Yes' : 'No' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Mode" width="110">
        <template slot-scope="scope">
          <el-tag :type="scope.row.recent_only ? 'warning' : 'primary'" size="small">
            {{ scope.row.recent_only ? 'Recent only' : 'Full' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Results" width="90">
        <template slot-scope="scope">
          <span>{{ scope.row.results_count || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Request ID" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.tinder_request">{{ scope.row.tinder_request.id }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="Created" min-width="150"></el-table-column>
      <el-table-column label="Actions" width="280" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="viewScan(scope.row)"
          >View</el-button>
          <el-button
            size="mini"
            :type="scope.row.repeatable ? 'warning' : 'success'"
            @click="toggleRepeat(scope.row)"
            :loading="scope.row._toggling"
          >{{ scope.row.repeatable ? 'Stop' : 'Repeat' }}</el-button>
          <el-button
            v-if="!scope.row.repeatable"
            size="mini"
            type="primary"
            @click="rescan(scope.row)"
            :loading="scope.row._rescanning"
          >Rescan</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrapper" v-if="totalScans > perPage">
      <el-pagination
        @current-change="changePage"
        :current-page="currentPage"
        :page-size="perPage"
        layout="prev, pager, next"
        :total="totalScans"
      ></el-pagination>
    </div>

    <!-- View Dialog -->
    <el-dialog
      title="Scan Details"
      :visible.sync="viewDialogVisible"
      width="70%"
    >
      <div v-if="selectedScan && selectedScan.tinder_request">
        <h3>Scan Info</h3>
        <el-row :gutter="20">
          <el-col :span="8"><strong>Search Name:</strong> {{ selectedScan.tinder_request.name }}</el-col>
          <el-col :span="8"><strong>Email:</strong> {{ selectedScan.tinder_request.email }}</el-col>
          <el-col :span="8"><strong>Gender:</strong> {{ selectedScan.tinder_request.gender }}</el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 10px;">
          <el-col :span="8"><strong>Age:</strong> {{ selectedScan.tinder_request.min_age }} - {{ selectedScan.tinder_request.max_age || selectedScan.tinder_request.min_age }}</el-col>
          <el-col :span="8"><strong>Location:</strong> {{ selectedScan.tinder_request.location_address }}</el-col>
          <el-col :span="8"><strong>Radius:</strong> {{ selectedScan.radius }} miles</el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 10px;">
          <el-col :span="8"><strong>Repeatable:</strong> {{ selectedScan.repeatable ? 'Yes' : 'No' }}</el-col>
          <el-col :span="8"><strong>User:</strong> {{ selectedScan.tinder_request.user ? selectedScan.tinder_request.user.email : 'N/A' }}</el-col>
        </el-row>

        <h3 style="margin-top: 20px;">Results ({{ selectedScan.tinder_request.result ? selectedScan.tinder_request.result.length : 0 }})</h3>
        <el-table :data="selectedScan.tinder_request.result || []" style="width: 100%;" max-height="400">
          <el-table-column prop="name" label="Name" min-width="120"></el-table-column>
          <el-table-column label="Photo" width="100">
            <template slot-scope="scope">
              <img v-if="scope.row.image_url" :src="scope.row.image_url" style="width: 60px; height: 60px; object-fit: cover; border-radius: 4px;" />
              <span v-else>No photo</span>
            </template>
          </el-table-column>
          <el-table-column prop="dob" label="DOB" min-width="100"></el-table-column>
          <el-table-column prop="tinder_user_id" label="Tinder ID" min-width="150"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getManualTinderScans, toggleRepeatable, showManualTinderScan, rescanManualTinderScan } from '../../api/manualTinderScansApi'

export default {
  name: 'ManualTinderScansPage',
  data() {
    return {
      scans: [],
      totalScans: 0,
      currentPage: 1,
      perPage: 25,
      loading: false,
      viewDialogVisible: false,
      selectedScan: null,
    }
  },
  created() {
    this.fetchScans()
  },
  methods: {
    async fetchScans() {
      this.loading = true
      try {
        const params = `page=${this.currentPage}&per_page=${this.perPage}`
        const res = await getManualTinderScans(params)
        this.scans = (res.data || []).map(s => ({ ...s, _toggling: false, _rescanning: false }))
        this.totalScans = res.total || 0
      } catch (e) {
        this.$message.error('Failed to load manual scans')
      }
      this.loading = false
    },
    changePage(page) {
      this.currentPage = page
      this.fetchScans()
    },
    async viewScan(scan) {
      try {
        const res = await showManualTinderScan(scan.id)
        this.selectedScan = res
        this.viewDialogVisible = true
      } catch (e) {
        this.$message.error('Failed to load scan details')
      }
    },
    async rescan(scan) {
      scan._rescanning = true
      try {
        await rescanManualTinderScan(scan.id)
        this.$message.success('Scan re-launched successfully')
      } catch (e) {
        this.$message.error('Failed to re-launch scan')
      }
      scan._rescanning = false
    },
    async toggleRepeat(scan) {
      scan._toggling = true
      try {
        const res = await toggleRepeatable(scan.id)
        scan.repeatable = res.repeatable
        this.$message.success(`Repeatable ${res.repeatable ? 'enabled' : 'disabled'}`)
      } catch (e) {
        this.$message.error('Failed to toggle repeatable status')
      }
      scan._toggling = false
    },
  }
}
</script>

<style scoped>
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.pagination-wrapper {
  margin-top: 20px;
  text-align: center;
}
</style>
